import Vue from "vue";
import router from "../../router";
import { ELYXCentralStore, SettingsStore } from "../ELYXStore";
import { connectGoogleCalendar } from "./integrationsHelpers";
import SettingsConstants from "./SettingsConstants";
import ELYXConstants from "../ELYXConstants";

const SettingsMethods = {
  async openSettingsModal(section = null) {
    ELYXCentralStore.methods.setModal(ELYXConstants.modals.Settings);

    /** Wait for settings modal to open */
    await Vue.nextTick();

    if (section || router.history.current.query.settings) {
      section = section || router.history.current.query.settings;
      /** If settings is specified in the route query, then open the specified settings tab. */
      const tab = SettingsConstants.tabs.find((tab) => tab.name === section);
      if (tab) {
        SettingsMethods.setTab(tab);
      }
    } else if (router.history.current.query.code) {
      /** If code is specified in the route query, it means we are being redirected from Google Calendar,
       * in which case we want to finalize connecting to Google and then setting the tab to integrations. */
      const decodedCode = decodeURIComponent(router.history.current.query.code);
      await connectGoogleCalendar(decodedCode);

      // Find the tab with the name 'integrations'
      const integrationsTab = SettingsConstants.tabs.find(tab => tab.name === 'integrations');

      if (integrationsTab) {
        // Set the tab using the found tab object
        SettingsMethods.setTab(integrationsTab);
      } else {
        console.error("Tab with name 'integrations' not found.");
      }
    } else {
      /** If no pre-existing tab specified and window is bigger , set first one */
      if (window.innerWidth >= 750) {
        SettingsMethods.setFirstTab();
      }
    }
  },

  closeSettingsModal() {
    ELYXCentralStore.methods.closeModal();
    SettingsStore.methods.setTab(null);
  },

  setTab(tab) {
    SettingsStore.methods.setTab(tab);
    /** Prevent navigation duplication error. @NB NOTICE OPTIONAL CHAINING OF QUERY */
    if (tab !== null && router.history.current.query?.settings !== tab.name) {
      router.push({ query: { settings: tab.name } });
    }
  },

  /** Used in minified / mobile settings for navigation */
  goBackToSettings() {
    SettingsMethods.setTab(null);
  },

  setFirstTab() {
    SettingsMethods.setTab(SettingsConstants.tabs[0]);
  },
};

export default SettingsMethods;
